import React from "react";
import { Icon } from "@iconify/react";
import Div from "../Div";

export default function SocialWidget() {
  return (
    <Div className="cs-social_btns cs-style1">
      <a
        href="https://www.facebook.com/streetstylincardetailing"
        target="_blank"
        rel="noreferrer"
        className="cs-center"
      >
        <Icon icon="fa6-brands:facebook" />
      </a>
      <a
        href="https://www.instagram.com/streetstylincardetailing/"
        target="_blank"
        rel="noreferrer"
        className="cs-center"
      >
        <Icon icon="fa6-brands:instagram" />
      </a>
    </Div>
  );
}
